import React, { useContext, useState } from "react";
import { TextField, Modal, Button } from "@material-ui/core";
import { useMutation, queryCache } from "react-query";

import { ModalBody, ModalButtons, ModalTitle } from "../../CreateProcurement/style";
import LoadingButton from "../../../../components/LoadingButton/LoadingButton";
import ToastContext from "../../../../util/toastContext";
import vendorsAPI from "../../../../redux/api/vendorsAPI";

const RejectVendorModal = ({ showNeedForAmendment, vendorDetailsQueryKey, setShowNeedForAmendment, vendorDetails }) => {
  const { showAlert } = useContext(ToastContext);

  const [reasonForRejection, setReasonForRejection] = useState("");
  const [rejectVendor, rejectVendorResp] = useMutation(vendorsAPI.rejectVendorProfile, {
    onSuccess: () => {
      setShowNeedForAmendment(false);
      setReasonForRejection("");
      queryCache.removeQueries(vendorDetailsQueryKey);
      showAlert({
        severity: "success",
        message: "Vendor's profile has been rejected",
      });
    },
    throwOnError: true,
  });

  const rejectVendorProfile = async () => {
    try {
      rejectVendor({
        vendorId: vendorDetails.id,
        description: reasonForRejection,
      });
    } catch (e) {
      showAlert({
        message: e.message,
        severity: "error",
      });
    }
  };

  return (
    <Modal open={showNeedForAmendment} onClose={() => setShowNeedForAmendment(false)}>
      <ModalBody style={{ top: "50px" }}>
        <ModalTitle>Kindly state your reasons</ModalTitle>
        <TextField
          id="outlined-textarea"
          multiline
          InputProps={{
            disableUnderline: true,
          }}
          onChange={(e) => setReasonForRejection(e.target.value)}
          value={reasonForRejection}
          variant="outlined"
          placeholder="Type reason here"
          rows={15}
          style={{ marginBottom: 20 }}
        />
        <ModalButtons>
          <LoadingButton
            style={{
              marginLeft: "0",
            }}
            disabled={!reasonForRejection}
            onClick={rejectVendorProfile}
            loading={rejectVendorResp.isLoading}
          >
            Reject
          </LoadingButton>
          <Button onClick={() => setShowNeedForAmendment(false)} variant="outlined">
            Cancel
          </Button>
        </ModalButtons>
      </ModalBody>
    </Modal>
  );
};

export default RejectVendorModal;
